export const setFloatingLabels = () => {
  const form = document.querySelectorAll("[data-wm-floating-labels-form]")[0];

  if (!form) {
    return;
  }

  const updateIsFloatingClass = (event, input) => {
    const element = event ? event.target : input;
    const container = $(element).parent()[0];

    container.classList.remove("is-floating");

    if (element.value !== "" || event?.type === "focus") {
      container.classList.add("is-floating");
    }
  };

  const selectors = `.form-field input:not([type=hidden]),
    .form-field select,
    .form-field textarea`;

  const setFloatingClassOnLangind = () => {
    form.querySelectorAll(selectors).forEach((input) => {
      updateIsFloatingClass(null, input);
    });
  };

  $(selectors).on("focus blur change", updateIsFloatingClass);

  setFloatingClassOnLangind();
};
